// 问卷库模块
export default {
    QuesLibrary: {
        QuestionnaireType: 'Questionnaire type',
        TemplatSistem: 'System template',
        TemplatSaya: 'My Template',
        BankSoalanSaya: 'My question bank',
        BankSoalanSistem: 'System question bank',
        QuestionBankAnalysis: 'Question bank analysis',
        LabelMasalah: 'Problem label',
        PengurusanMasalah: 'Problem management',
        Tambah: 'Add',
        Name: 'Name',
        SortOrder: 'Sort Order',
        Operate: 'Operate',
        AreYouSureToDeleteIt: 'Are you sure to delete it?',
        Delete: 'Delete',
        Edit: 'Edit',
        NewlyAdded: 'Newly added',
        ModifySortingPosition: 'Modify sorting position',
        Category: 'Category',
        SortPosition: 'Sort Position',
        PleaseEnterAName: 'Please enter a name',
        SelectCategory: 'Select Category',
        PleaseSelectCategory: 'Please select the category you belong to',
        All: 'All',
        QuestionnaireName: 'Questionnaire Name',
        NumberOfCitations: 'Number of citations',
        Type: 'Type',
        DesignQuestionnaire: 'Design questionnaire',
        Preview: 'Preview',
        Modify: 'Modify',
        MyTemplate: 'My Template',
        CannotExceed5MB: 'The size of the uploaded file cannot exceed 5MB. Please reselect the image!',
        PleaseUploadPictures: 'Please upload pictures',
        QuestionBankList: 'Question bank list',
        NumberOfRecords: 'Number of records',
        Refresh: 'Refresh',
        SearchQuestionBankName: 'Please enter the name of the question bank to search for',
        SearchQuestionBankCategories: 'Please enter the category of question bank to search for',
        Query: 'Query',
        CreateANewQuestionBank: 'Create a new question bank',
        QuestionBankNumber: 'Question bank number',
        None: 'None',
        QuestionBankName: 'Question bank name',
        QuestionBankCategory: 'Question bank category',
        Creator: 'Creator',
        NumberOfTestQuestions: 'Number of test questions',
        Memo: 'Memo',
        CreateQuestion: 'Create Question',
        EditQuestion: 'Edit Question',
        EditQuestionBank: 'Edit question bank',
        AddQuestionBank: 'Add question bank',
        QuestionBankInfo: 'Question bank information',
        ConfirmDeletionOfQuestionBank: 'Are you sure to delete this question bank?',
        SelectTheQuestionBankToDelete: 'Please select the question bank to delete first',
        DeletSelectedQuestionBank: 'Are you sure to delete the selected question bank?',
        CancelTheSelectedQuestionBank: 'Are you sure to cancel the selected question bank?',
        CancelFavorite: 'Cancel Favorite',
        Prompt: 'Tip',
        ChooseAQuestionBankToBookmark: 'Please select the question bank you want to bookmark first',
        CanceledSuccessfully: 'Canceled successfully',
        QuestionBankNumberLimit: '1-32 characters, using letters, numbers, and underscores',
        EnterOrSelectArticleLabel: 'Enter/Select Article Label',
        Notes: 'Notes',
        Save: 'Save',
        Resetting: 'Resetting',
        CharacterMismatch: 'Please use letters, numbers, and underscores',
        LengthMismatch: 'Between 1 and 32 characters in length',
        EnterTheNameOfTheQuestionBank: 'Please enter the name of the question bank',
        EnterQuestionBankCategory: 'Please enter the question bank category',
        EnterQuestionBankNotes: 'Please enter a note for the question bank',
        SelfBuiltQuestionBank: 'Self built question bank',
        DeleteQuestionBankFromFavoritesList: 'Are you sure to delete this question bank from the favorites list?',
        ChooseToCancelTheFavoriteQuestionBank: 'Please select the question bank you want to cancel your favorites from first',
        QuestionLabelName: 'Question label name',
        AddQuestionLabel: 'Add Question Label',
        TagName: 'Tag name',
        ModifyProblemLabels: 'Modify problem labels',
        DeleteTitleTip: 'After deletion, all questions within the group will be deleted',
        DeleteConfirmation: 'Delete confirmation',
        ExportData: 'Export Data',
        NumberOfRespondents: 'Number of respondents',
        NumberOfRespondents: 'Number of respondents',
        Download: 'Download',
        LoadMore: 'Load more',
        ModificationPrompt: 'Modification prompt',
        ConfirmModifyingTheQuestionnaire: 'Are you sure to modify this questionnaire? All data collection for this questionnaire will be stopped, and the answer sheet link will be temporarily closed!',
        DataType: 'Data type',
        RawData: 'Raw data',
        CodedData: 'Coded data',
        ExhibitionFormat: 'Exhibition format',
        OneQuestionOneColumn: 'One question, one column',
        OneQuestionWithMultipleColumns: 'One question with multiple columns',
        Export: 'Export',
        CustomTitle: 'Custom Title',
        Pie: 'Pie',
        Histogram: 'Histogram',
        BarChart: 'Bar chart',
        Ring: 'Ring',
        StackedBarChart: 'Stacked bar chart',
        StackedBarChart2: 'Stacked bar chart',
        RadarChart: 'Radar chart',
        ProblemList: 'Question list',
        MultipleChoiceBank: 'Please choose multiple question bank',
        EnterQuestionName: 'Please enter the question name',
        EnterQuestionnaireLabel: 'Please enter the questionnaire label',
        ConfirmDeletionSelectedIssues: 'Are you sure to delete the selected question?',
        IssueNames: 'Question name',
        AffiliatedQuestionBank: 'Affiliated question bank',
        QuestionnaireLabel: 'Questionnaire label',
        AreYouSureToDeleteTheIssue: 'Are you sure to delete this question?',
        Easy: 'Easy',
        Easier: 'Easier',
        Middle: 'Moderate',
        RelativelyDifficult: 'More difficult',
        Difficult: 'Difficult',
        NoLimit: 'No limit',
        Radio: 'Radio',
        SelectTheQuestionToDelete: 'Please select question to delete first',
        TestQuestionManagement: 'Test question management',
        EditItem: 'Edit item',
        Success: 'Success'
    },
  };